import * as React from "react";
import { useLocation } from "react-router-dom";
import { Box, Button, Stack } from "@mui/material";
import Typography from "@mui/material/Typography";
import useTranslation from "components/customHooks/translations";
import { Formik } from "formik";
import CustomerForm from "./CustomerForm";

const NewCustomer = () => {
  const { pathname } = useLocation();
  const translation = useTranslation();

  return (
    <Box>
      <CustomerForm />
    </Box>
  );
};

export default NewCustomer;
